import { useCallback, useEffect, useState } from "react";
import { Container, Table } from "rsuite";
import { useCustomTheme } from "../../../hooks/useCustomTheme";
import { ContentHeader } from "../../../components/ContentHeader";
import { useAuth } from "../../../hooks/auth";
import api from "../../../services/api";
import { CustomHeaderCell } from "../../../components/CustomHeaderCell";
import { CustomCell } from "../../../components/CustomCell";
import { moeda } from "../../../components/funcoes";
import { RelatorioFiltroPeriodo } from "../../../components/RelatorioFiltroPeriodo";

const { Column } = Table;

const RelatorioCuponsUtilizados = () => {
  const { id_empresa } = useAuth();
  const [dataInicio, setDataInicio] = useState(null);
  const [dataFim, setDataFim] = useState(null);
  const [loading, setLoading] = useState(true);
  const [registros, setRegistros] = useState([]);
  const [total, setTotal] = useState(0);
  const [totalLiquido, setTotalLiquido] = useState(0);
  const [descontoTotal, setDescontoTotal] = useState(0);
  const { theme } = useCustomTheme();

  const imprimir = () => {
    const relatorio = { registros, total, descontoTotal, totalLiquido };
    localStorage.setItem('relatorioCuponsUtilizados', JSON.stringify(relatorio));
    window.open(
      `/g_imprimir_relatorio_cupons_utilizados`,
      'Relatorio',
      'height=800,width=950',
    );
  };

  const filtrar = useCallback(async () => {
    setLoading(true);
    let inicial = null,
      final = null;
    if (dataInicio && dataFim) {
      inicial = dataInicio;
      final = dataFim;
    } else {
      let data = new Date();
      let primeiroDia = new Date(data.getFullYear(), data.getMonth(), 1);
      let ultimoDia = new Date(data.getFullYear(), data.getMonth() + 1, 0);
      inicial =
        primeiroDia.getFullYear() +
        '-' +
        ('00' + (primeiroDia.getMonth() + 1)).slice(-2) +
        '-' +
        ('00' + primeiroDia.getDate()).slice(-2);
      final =
        ultimoDia.getFullYear() +
        '-' +
        ('00' + (ultimoDia.getMonth() + 1)).slice(-2) +
        '-' +
        ('00' + ultimoDia.getDate()).slice(-2);
    }
    setDataInicio(inicial);
    setDataFim(final);
    await api
      .post('pedido/relatorioCuponsUsados', {
        IdEmpresa: id_empresa,
        DataInicial: inicial,
        DataFinal: final,
      })
      .then((res) => {
        if(res.data.length){
          setRegistros(res.data);
          setTotal(res.data.reduce((acc, item) => acc + +item.ValorTotal, 0));
          setDescontoTotal(res.data.reduce((acc, item) => acc + +item.DescontoTotal, 0));
          setTotalLiquido(
            res.data.reduce((acc, item) => acc + +item.ValorComDesconto, 0)
          );
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dataFim, dataInicio, id_empresa]);

  useEffect(() => {
    filtrar();
  }, [filtrar]);

  return (
    <Container
      style={{
        padding: '10px',
        height: 'calc(100vh - 60px)',
        backgroundColor: theme.colors.background,
      }}
      >
      <ContentHeader
        title="Relatório de Cupons Utilizados"
        thirdComponent={
          <RelatorioFiltroPeriodo
            dataInicio={dataInicio}
            dataFim={dataFim}
            onChangeDataInicio={setDataInicio}
            onChangeDataFim={setDataFim}
            onImprimir={imprimir}
          />
        }
      />
      <Table
        height={window.innerHeight - 200}
        data={registros}
        bordered={true}
        loading={loading}
        style={{
          overflowY: 'auto',
          borderColor: theme.colors.backgroundSecondary,
          backgroundColor: theme.colors.backgroundSecondary,
          color: theme.colors.textSecondary,
        }}
        locale={{
          emptyMessage: 'dados não encontrados',
          loading: 'Carregando...',
        }}
      >
        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={1}
        >
          <CustomHeaderCell>Cupom</CustomHeaderCell>
          <CustomCell dataKey="Cupom" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={1}
        >
          <CustomHeaderCell>Qtd. Utilizados</CustomHeaderCell>
          <CustomCell>{(rowData) => <text>{+(rowData.Quantidade)}</text>}</CustomCell>
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={1}
        >
          <CustomHeaderCell>Desconto Total</CustomHeaderCell>
          <CustomCell>{(rowData) => <text>{moeda(rowData.DescontoTotal)}</text>}</CustomCell>
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={1}
        >
          <CustomHeaderCell>Total com Desconto</CustomHeaderCell>
          <CustomCell>
            {(rowData) => <text>{moeda(rowData.ValorComDesconto)}</text>}
          </CustomCell>
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
        >
          <CustomHeaderCell>Valor Total</CustomHeaderCell>
          <CustomCell>
            {(rowData) => <text>{moeda(rowData.ValorTotal)}</text>}
          </CustomCell>
        </Column>
      </Table>
    </Container>
  );
}

export default RelatorioCuponsUtilizados;
